import { Type } from 'class-transformer';
import { IsDefined, IsNotEmpty, ValidateNested } from 'class-validator';
import { IsMongoIdObject } from '../../../decorators/is-mongo-object-id.decorator';
import { UserId } from '../../../types';
import { UserIdentityPopulateAvatarDto } from './user-identity-populate-avatar.dto';

export class UserCreatedByPopulateDto {
  @ValidateNested()
  @Type(() => UserIdentityPopulateAvatarDto)
  @IsDefined()
  identity!: UserIdentityPopulateAvatarDto;

  @IsMongoIdObject()
  @IsNotEmpty()
  _id!: UserId;
}
